<script>

  export default {
    name: 'admin-home',
    components: {
   
    },
    data: () => ({
      filename: '',
      monthPicker: null,
      monthPickerModal: null,
      //TEMP DATA BELOW FOR DEMO,,, 
      documents: {
        2023: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        2024: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'],
      },
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      yearSelected: null,
      yearSelectedLoading: true,
      years: [2024, 2023],
    }),
    methods: {
      async onYearSelect(year) {
        //if (!documents[year])
        //set loading (show getting docs message?)
        //await fetch documents
        // set !loading
        console.log(year)
        this.yearSelectedLoading = true
        setTimeout(() => {
          this.yearSelectedLoading = false
        }, 600)
      },
    },
    computed: {},
    async created() {
      //TODO: pull list here if using
      console.log('welcome to admin')
      this.yearSelected = this.years.sort((a, b) => b - a)[0]
      setTimeout(() => {
        this.yearSelectedLoading = false
      }, 1000)
    }
  }
</script>
<template>
  <v-container class="main-container d-flex flex-column align-center">
<h1 class="primary--text"> Document Management</h1>
    <v-card width="100%"  max-width="600" class="mt-8">
<v-card-title class="text-h5 font-weight-bold primary--text">
 Add new Document
</v-card-title>
    <v-card-text>

      <v-form>
        <v-dialog
        ref="dialog"
        v-model="monthPickerModal"
        :return-value.sync="monthPicker"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="monthPicker"
            label="Month/Year"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="monthPicker"
          type="month"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="monthPickerModal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(monthPicker)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
<v-text-field v-model="filename" label="File name"></v-text-field>
<v-file-input
    accept=".doc,.pdf"
    label="File input"
    append-icon="mdi-paperclip"
    prepend-icon=""
  ></v-file-input>
      </v-form>
   </v-card-text>
   <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="primary"><v-icon left>mdi-file-upload</v-icon> UPLOAD</v-btn>
   </v-card-actions>
  </v-card>

  <!-- TEMP FOR DEMO -->

  <v-card width="100%"  max-width="600" class="mt-10">
    <v-card-title class="text-h5 font-weight-bold primary--text">Edit Documents
      <v-spacer></v-spacer>
      <v-select v-model="yearSelected" color="primary" hide-details :items="years" label="Year" @change="onYearSelect"></v-select>
    </v-card-title>
    <v-card-text style="height: 50vh; overflow-y: auto;">
      <v-list-item v-if="yearSelectedLoading">
        <v-list-item-content>
          <v-list-item-title>Getting {{ yearSelected }} documents...</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-progress-circular indeterminate color="primary" :vaule="yearSelectedLoading"></v-progress-circular>
        </v-list-item-icon>
      </v-list-item>
      <v-list v-else>
        <!-- <v-list subheader>
          <v-subheader>Month</v-subheader> -->
        <template v-for="month in months">
          <v-list-item :key="month">
            <v-list-item-content>
              <v-list-item-title v-text="month" class="font-weight-bold"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-btn color="warning" icon > <v-icon color="warning"> mdi-pencil </v-icon></v-btn>
              <v-btn color="error" icon > <v-icon color="error"> mdi-trash-can </v-icon></v-btn>
             
            </v-list-item-icon>
          </v-list-item>
          <v-divider :key="`d-${month}`"></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
  </v-container>
</template>
<style scoped>

</style>
